var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccompagnementGestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.0674V17.9335C8.00009 17.686 8.10548 17.4486 8.29301 17.2735C8.48054 17.0985 8.73485 17.0001 9.00006 17H18.9993C19.1306 17 19.2607 17.0241 19.3821 17.071C19.5035 17.1179 19.6138 17.1866 19.7067 17.2733C19.7997 17.36 19.8734 17.4629 19.9237 17.5762C19.974 17.6895 20 17.8109 20 17.9335V23.0674C19.9996 23.3149 19.894 23.5522 19.7064 23.727C19.5187 23.9019 19.2644 24.0001 18.9993 24H9.00006C8.73503 23.9999 8.48087 23.9017 8.29337 23.7268C8.10587 23.552 8.00036 23.3148 8 23.0674V23.0674Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.6981L11.6472 14.0891C11.692 13.9075 11.773 13.7362 11.8855 13.5852C11.998 13.4341 12.1398 13.3062 12.3029 13.2088C12.4659 13.1113 12.647 13.0462 12.8358 13.0172C13.0246 12.9882 13.2174 12.9959 13.4031 13.0397L21.887 15.0447C22.0728 15.0886 22.2479 15.1679 22.4023 15.2781C22.5567 15.3882 22.6875 15.527 22.787 15.6866C22.8866 15.8461 22.953 16.0233 22.9825 16.2079C23.0121 16.3926 23.0041 16.5812 22.9591 16.7628V16.7628L21.9339 20.9115C21.8842 21.1126 21.7902 21.3008 21.6584 21.4628C21.5267 21.6248 21.3604 21.7567 21.1711 21.8494C20.9819 21.9421 20.7742 21.9933 20.5626 21.9994C20.3511 22.0055 20.1407 21.9664 19.9462 21.8848",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20C14.5989 20 14.6956 20.0293 14.7778 20.0843C14.86 20.1392 14.9241 20.2173 14.9619 20.3087C14.9998 20.4 15.0097 20.5006 14.9904 20.5975C14.9711 20.6945 14.9235 20.7836 14.8536 20.8536C14.7836 20.9235 14.6945 20.9711 14.5975 20.9904C14.5006 21.0097 14.4 20.9998 14.3087 20.9619C14.2173 20.9241 14.1392 20.86 14.0843 20.7778C14.0293 20.6956 14 20.5989 14 20.5C14 20.3674 14.0527 20.2402 14.1464 20.1464C14.2402 20.0527 14.3674 20 14.5 20Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18C1.00099 17.0527 1.25852 16.119 1.75154 15.2752C2.24457 14.4314 2.95911 13.7015 3.83679 13.1451C4.71446 12.5886 5.73037 12.2215 6.80152 12.0736C7.87268 11.9257 8.96868 12.0013 10 12.2942",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C4.66895 4.63251 5.4707 5.13559 6.3574 5.47921C7.24411 5.82283 8.1976 5.99995 9.16098 6C10.1373 6.00088 11.1034 5.81951 12 5.46703",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 2C8.79144 2.00007 9.56477 2.23472 10.2225 2.67428C10.8803 3.11385 11.3929 3.73858 11.6956 4.46949C11.9983 5.2004 12.0775 6.00466 11.9231 6.78056C11.7687 7.55646 11.3877 8.26917 10.8283 8.82854C10.2689 9.38792 9.55615 9.76885 8.78024 9.92316C8.00432 10.0775 7.20007 9.99825 6.46919 9.69548C5.7383 9.39272 5.11361 8.88003 4.6741 8.22225C4.23459 7.56446 4 6.79111 4 6C4 5.47468 4.10347 4.95451 4.30451 4.46919C4.50555 3.98387 4.80022 3.54289 5.17169 3.17146C5.54316 2.80002 5.98415 2.50539 6.46949 2.30439C6.95483 2.10339 7.47501 1.99996 8.00033 2V2Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccompagnementGestion);
export default __webpack_public_path__ + "static/media/accompagnement_gestion.7032cf71d7583075086ecd46ba217bee.svg";
export { ForwardRef as ReactComponent };